
<template lang="pug">
  .tab-wrapper
    button.tab--accordion__header(@click="activate", v-if="$mq === 'mobile'", :class="headerClass")
      span {{ heading }}
      icon.tab--accordion__header__icon(:name="icon", width="13px" height="13px")
    transition(name="slide-vertical", v-if="$mq === 'mobile'", @after-enter="setContentHeight")
      .tab.tab--accordion(v-if="active", ref="content", :style="contentStyle")
        .tab__content
          slot
    .tab(v-else-if="active", ref="content", :style="contentStyle")
      .tab__content
        slot
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'Tab',
    components: { Icon },
    props: {
      heading: {
        type: String,
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        active: true,
        contentStyle: {},
      }
    },
    computed: {
      icon () {
        return this.active ? 'minus' : 'plus';
      },
      headerClass () {
        return {
          'is-active': this.active,
        };
      },
    },
    mounted () {
      this.setContentHeight();
      // NOTE: this has to be set to false after mount or scrollHeight will be 0
      this.active = this.selected;
      this.$parent.addTab(this);
      window.addEventListener('resize', () => this.setContentHeight());
    },
    beforeDestroy () {
      this.active = false;
      this.$parent.removeTab(this);
    },
    methods: {
      activate () {
        if (this.active && this.$mq === 'mobile') {
          this.active = false;
        } else {
          this.$parent.activate({ heading: this.heading });
        }
      },
      setContentHeight () {
        if (this.$mq === 'mobile' && this.$refs.content) {
          let height = this.$refs.content.scrollHeight;

          this.contentStyle = {
            'max-height': `${height}px`,
          };
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .tab--accordion {
    &__header {
      border: none;
      padding: 25px 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: rem(18);
      font-weight: bold;
      line-height: 1.28;
      width: 100%;
      background-color: transparent;

      &__icon {
        fill: $text--main;
      }
    }

    .tab__content {
      padding: $grid-gutter / 2;
    }
  }
</style>
